import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

const createLoggerService = () => {
  let isInitialized = false;
  const initializeLogger = (configJSON) => {
    if (isInitialized) {
      console.warn('Datadog has already been initialized.');
      return;
    }

    if(!configJSON.datadog?.applicationId){
      console.error("Datadog configuration not available");
      return;
    }
    // Initialize Datadog RUM
    datadogRum.init({
      applicationId: configJSON.datadog.applicationId,
      clientToken: configJSON.datadog.clientToken,
      site: configJSON.datadog.site,
      service: configJSON.datadog.service,
      env: configJSON.appEnv.toLowerCase(), //env value always needs to be in lowercase
      version: configJSON.appVersion,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      trackUserInteractions: true,
      trackFrustrations: true,
      useSecureSessionCookie: true,
      allowedTracingUrls: [window.location.origin]
    });
    datadogLogs.init({
      clientToken: configJSON.datadog.clientToken,
      site: configJSON.datadog.site,
      service: configJSON.datadog.service,
      env: configJSON.appEnv.toLowerCase(),
      version: configJSON.appVersion,
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      useSecureSessionCookie: true
    });
    isInitialized = true;
  };

  const setUser = (user) => {
    if (!isInitialized) {
      console.error('Datadog must be initialized before setting the user.');
      return;
    }
    datadogRum.setUser(user);
    datadogLogs.setUser(user);
  };
  return {
    initializeLogger,
    setUser
  };
};

const loggerService = createLoggerService();
export default loggerService;
